import {put, takeLatest, call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";

import {
    CHANGE_EXTRAS_VISIBILITY,
    CHANGE_EXTRAS_VISIBILITY_SUCCESS,
    CHANGE_EXTRAS_VISIBILITY_ERROR,
}
    from "../../../actions/menu/extras";

function* changeExtrasVisibilitySaga(action) {
    try {
        yield call(extraService.ChangeExtrasVisibility, action.payload)
        yield put({
            type: CHANGE_EXTRAS_VISIBILITY_SUCCESS,
            payload: action.payload.data
        });


    } catch (error) {
        yield put({
            type: CHANGE_EXTRAS_VISIBILITY_ERROR,error: error.data
        });
    }
}


export function* changeExtrasVisibilitySagaWatcher() {
    yield takeLatest(CHANGE_EXTRAS_VISIBILITY, changeExtrasVisibilitySaga);
}